import { FlatAspect, ItemAttributeOption } from "@/models/HomePageSearchResponse";

const RIDER_LEVEL_OPTIONS: FlatAspect[] = [
  { id: "222", label: "Beginner", slug: "beginner", order: 1 },
  { id: "218", label: "Novice", slug: "novice", order: 2 },
  { id: "219", label: "Intermediate", slug: "intermediate", order: 3 },
  { id: "220", label: "Advanced", slug: "advanced", order: 4 },
];

export default RIDER_LEVEL_OPTIONS;

export const RIDER_LEVEL_ATTRIBUTE_OPTIONS: ItemAttributeOption[] = RIDER_LEVEL_OPTIONS.map((option) => ({
  value: option.id,
  label: option.label,
}));